import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NavigationModule } from 'app/shared/navigation/navigation.module';
import { LsAccountingRoutingModule } from './ls-accounting.routing';
import { DynamicTranslationModule } from 'app/shared/dynamic-translation/dynamic-translation.module';
import { LsAccountingSetupComponent } from './ls-accounting-setup/ls-accounting-setup.component';
import { ComponentsModule } from 'app/shared/components/components.module';
import { ButtonModule } from 'app/shared/components/button/button.module';

@NgModule({
  imports: [
    CommonModule,
    NavigationModule,
    LsAccountingRoutingModule,
    DynamicTranslationModule,
    ComponentsModule,
    ButtonModule
  ],
  declarations: [LsAccountingSetupComponent],
  exports: [LsAccountingSetupComponent]
})
export class LsAccountingModule {}
